/** Default support contact when not overridden by config or props. */
export const ACCESS_DENIED_DEFAULT_SUPPORT_EMAIL = 'https://bibliotele.com/eng/lets-talk/';

export const ACCESS_DENIED_HEADING = 'Access Denied';

export const ACCESS_DENIED_BODY_PRIMARY =
  "Sorry, your organisation doesn't appear to have an active subscription for this content.";

export const ACCESS_DENIED_BODY_CONTACT_PREFIX = 'If you would like to speak to our team, please write to us at';

export const ACCESS_DENIED_TIP =
  'Tip: If you believe this is incorrect, ask your library/institution administrator to confirm the subscription level for your organisation.';
